<!--
  A person's color, filled to show how much of their share is paid:
  solid = paid, half = partly paid, ring = not paid, faint dashed ring = not ticked.
  Color says who; fill says status, so it still reads for colorblind friends.
-->
<script lang="ts">
  import { colorOf } from "../lib/colors.ts";

  type Status = "paid" | "partial" | "unpaid" | "off";

  let {
    color,
    status = "unpaid",
    size = 22,
    label = "",
    pending = false,
    text = "",
  }: { color: string; status?: Status; size?: number; label?: string; pending?: boolean; text?: string } = $props();

  const fill = $derived(status === "paid" ? 100 : status === "partial" ? 50 : 0);
</script>

<span
  class="swatch"
  class:off={status === "off"}
  class:pending
  style:--c={colorOf(color)}
  style:--s="{size}px"
  style:--fill="{fill}%"
  role={label ? "img" : undefined}
  aria-label={label || undefined}
  title={label || undefined}
>
  {#if text}<span class="t" class:on={status === "paid"}>{text}</span>{/if}
</span>

<style>
  .swatch {
    position: relative;
    display: inline-grid;
    place-items: center;
    flex: none;
    width: var(--s);
    height: var(--s);
    border-radius: 50%;
    border: 2px solid var(--c);
    background: var(--surface);
    overflow: hidden;
    vertical-align: middle;
  }

  /* The fill rises from the bottom like a level: the one animated moment in the app. */
  .swatch::after {
    content: "";
    position: absolute;
    inset: auto 0 0 0;
    height: var(--fill);
    background: var(--c);
    transition: height 420ms cubic-bezier(0.2, 0.8, 0.2, 1);
  }

  .swatch.off {
    border: 1.5px dashed var(--rule-strong);
    background: transparent;
  }

  .swatch.off::after {
    display: none;
  }

  .swatch.pending {
    outline: 1.5px dashed var(--muted);
    outline-offset: 2px;
  }

  .t {
    position: relative;
    z-index: 1;
    font-size: calc(var(--s) * 0.38);
    font-weight: 700;
    line-height: 1;
    color: var(--c);
    letter-spacing: 0;
  }

  .t.on {
    color: #fff;
  }
</style>
